var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxs",attrs:{"height":_vm.windowHeight}},[_c('iframe',{attrs:{"id":"mapPage","width":"100%","height":_vm.windowHeight,"frameborder":"0","src":"https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=RSEBZ-Z35HS-4F4O3-6GT5A-XQB4H-TOBFA&referer=myapp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }